import React, { Fragment } from "react";
import { Navigate } from "react-router-dom";
import { connect } from "react-redux";
const CheckUnauth = ({ token, pathname }) => {
  return (
    <Fragment>
      {!token && <Navigate to="/login" state={pathname} replace />}
    </Fragment>
  );
};
const mapStateToProps = (state) => ({
  token: state.auth.token,
});
export default connect(mapStateToProps, {})(CheckUnauth);
